import React from 'react';
import { connect } from 'react-redux';
import { Redirect, Route, Switch, withRouter } from 'react-router-dom';

import Dashboard from './layouts/Dashboard';
import Help from './layouts/Help';
import Login from './layouts/Login';
import Logout from './layouts/Logout';

import { selectUserId } from './modules/selectors/session';

const PrivateRoute = ({
                        component: Component,
                        componentOptions,
                        childComponent,
                        childProps,
                        userId,
                        ...rest
                      }) => (
  <Route
    {...rest}
    render={props => (
      (userId !== undefined) ? (
          <Component
            {...props}
            componentOptions={componentOptions}
            childComponent={childComponent}
            childProps={childProps}
          />
        ) :
        <Redirect to={{ pathname: '/login' }} />
    )}
  />
);

// Only logged in users can access these routes,
// otherwise the user will be redirect to the login page
const ConnectedPrivateRoute = withRouter(connect(state =>
  ({ userId: selectUserId(state) }))(PrivateRoute));

const App = () => (
  <Switch>
    <ConnectedPrivateRoute path="/" exact component={Dashboard} />
    <ConnectedPrivateRoute path="/help" exact component={Help} />

    <Route path="/logout" component={Logout} />
    <Route path="/login" component={Login} />
  </Switch>
);

export default App;
